import { render, staticRenderFns } from "./AgentRequestsTable.vue?vue&type=template&id=473c7db0"
import script from "./AgentRequestsTable.vue?vue&type=script&lang=js"
export * from "./AgentRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports